import { css, html, LitElement } from "lit";

export class ButtonComponent extends LitElement {
  constructor() {
    super();
    this.label = "";
  }

  static styles = [
    css`
      :host {
        display: inline-block;
        color: #FFF;
        background-color: rgb(65, 138, 207);
        padding: 12px 50px;
        border: 2px solid rgb(65, 138, 207);
        border-radius: 5px;
        cursor: pointer;
        font-size: 22px;
        text-align: center;
        text-decoration: none;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        text-transform: uppercase;
        font-weight: bold;
        text-align: center;
      }

      :host(:hover) {        
        background-color: rgb(43, 106, 165);
      }
    `,
  ];

  static properties = {
    label: { type: String },
  };

  render() {
    return html` <slot>${this.label}</slot> `;
  }
}

customElements.define("button-component", ButtonComponent);
